import { render, staticRenderFns } from "./TableApprInfo.vue?vue&type=template&id=2992a553&scoped=true&"
import script from "./TableApprInfo.vue?vue&type=script&lang=js&"
export * from "./TableApprInfo.vue?vue&type=script&lang=js&"
import style0 from "./TableApprInfo.vue?vue&type=style&index=0&id=2992a553&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2992a553",
  null
  
)

export default component.exports